import React, { useState, useEffect, useCallback } from "react";
import { Link } from "react-router-dom";
import { Button, Container, Divider, Grid, Image } from "semantic-ui-react";
import { Formik } from "formik";
import MyTextInput from "../../../app/common/form/MyTextInput";
import MySelectInput from "../../../app/common/form/MySelectInput";
import MyCheckboxInput from "../../../app/common/form/MyCheckboxInput";
import MyTinyMCE from "../../../app/common/form/MyTinyMCE";
import { updateProfile } from "../adminActions";
import { useSelector } from "react-redux";

import firebase from "../../../app/config/firebase";
const firestore = firebase.firestore();
const BMS_BASE_URL = "https://bms.igotravel.co.za";

const divisionOptions = [
    { key: "", text: "Choose a Division", value: "" },
    { key: "Leisure", text: "Leisure", value: "Leisure" },
    { key: "Non-Leisure", text: "Non-Leisure", value: "Non-Leisure" },
];

export default function UsersDetailedPage(props) {
    const [user, setUser] = useState({});
    const [userUid, setuserUid] = useState("");
    const [impersonating, setImpersonating] = useState(false);
    const readStoredValue = (raw) => {
        if (!raw) return null;
        try {
            let parsed = JSON.parse(raw);
            if (parsed && typeof parsed === "object" && "value" in parsed) {
                return parsed.value;
            }
            if (typeof parsed === "string") {
                parsed = JSON.parse(parsed);
                if (parsed && typeof parsed === "object" && "value" in parsed) {
                    return parsed.value;
                }
            }
        } catch (error) {
            // ignore parse errors
        }
        return raw;
    };

    var parts = window.location.href.split("/");
    var lastSegment = parts.pop() || parts.pop();
    const { currentUserProfile } = useSelector((state) => state.profile);
    console.log("currentUserProfile", currentUserProfile);

    useEffect(() => {
        var userId = props.match.params.id;
        setuserUid(userId);

        const unsubscribe = firestore
            .collection("users")
            .doc(userId)
            .onSnapshot((snapshot) => {
                let userData = snapshot.data()

                if (userData && userData.moreInfoMessage && userData.moreInfoMessage !== "") {
                    userData.moreInfoMessage = userData.moreInfoMessage;
                } else {
                    userData.moreInfoMessage = '<div style="font-family: Calibri; font-size: 14px; line-height: 20px;"><p>Good afternoon,</p><p>Thank you for your lovely enquiry submitted to our website. In order for me to offer you the best value quotation, I would like to get a few additional details to proceed.</p><ul><li>Preferred destination, country or city?</li><li>Proposed dates of travel?</li><li>How many passengers, and if children/teens please provide ages at time of travel?</li><li>Will you be departing from Johannesburg, Durban or Cape Town?</li><li>Any special requirement e.g. honeymoon?</li><li>Please advise what your budget is and I can provide a few appropriate options?</li><li>Please provide your telephone number to contact you on and best times to call?</li></ul><p>Once I have these details I can work on the quote. Please feel free to contact me should you have any queries.</p><p>Kind regards</p></div>';
                }

                setUser(userData);

            });

        return () => unsubscribe();
    }, []);

    const leadStatus = [
        { key: "All", text: "All", value: "All" },
        { key: "Assigned", text: "Assigned", value: "Assigned" },
        { key: "Booked", text: "Booked", value: "Booked" },
        { key: "Lost Lead", text: "Lost Lead", value: "Lost Lead" },
        { key: "Quoted", text: "Quoted", value: "Quoted" },
        { key: "Pending", text: "Pending", value: "Pending" },
        { key: "Follow Up", text: "Follow Up", value: "Follow Up" },
        { key: "Duplicate", text: "Duplicate", value: "Duplicate" },
        { key: "Awaiting Rates", text: "Awaiting Rates", value: "Awaiting Rates" },
        { key: "Travel out of date range", text: "Travel out of date range", value: "Travel out of date range" },
        { key: "Prospective", text: "Prospective", value: "Prospective" },
        { key: "Cancelled BKG", text: "Cancelled BKG", value: "Cancelled BKG" },
        { key: "Awaiting client feedback", text: "Awaiting client feedback", value: "Awaiting client feedback" },
        { key: "Archived", text: "Archived", value: "Archived" },
    ];
    const historyMonthOptions = [
        { key: "30days", text: "Last 30 days", value: "30days" },
        { key: 6, text: "Last 6 months", value: 6 },
        { key: 12, text: "Last 12 months", value: 12 },
        { key: 18, text: "Last 18 months", value: 18 },
        { key: 24, text: "Last 24 months", value: 24 },
        { key: "All", text: "All time", value: "All" },
    ];

    async function impersonateSelectedUser() {
        if (!userUid || userUid.length <= 1) {
            return;
        }
        if (!window.confirm("Impersonate this user? You will be logged in as them.")) {
            return;
        }
        setImpersonating(true);
        try {
            const currentUser = firebase.auth().currentUser;
            if (!currentUser) {
                throw new Error("Please sign in again");
            }
            const idToken = await currentUser.getIdToken();
            const authResponse = await fetch(`${BMS_BASE_URL}/api/impersonate/token`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${idToken}`,
                },
                body: JSON.stringify({ target_user_id: userUid }),
            });
            if (!authResponse.ok) {
                const errorPayload = await authResponse.json().catch(() => ({}));
                throw new Error(errorPayload?.message || "Not allowed to impersonate");
            }
            const payload = await authResponse.json().catch(() => ({}));
            const token = payload?.custom_token;
            if (!token) {
                throw new Error("Could not create impersonation token");
            }
            await firebase.auth().signInWithCustomToken(token);
            window.location.replace("/");
        } catch (error) {
            window.alert(error?.message || "Impersonation failed");
            setImpersonating(false);
        }
    }

    return (
        <Container>
            <Formik
                enableReinitialize={true}
                initialValues={user}
                validate={(values) => {
                    const error = {};

                    return error;
                }}
                onSubmit={async (values, { setSubmitting, resetForm }) => {
                    values.id = lastSegment;
                    values.leadStatusOrder = readStoredValue(values.leadStatusOrder);
                    values.noLeadsLoad = readStoredValue(values.noLeadsLoad);
                    await updateProfile(values);
                    resetForm({
                        uploadFile: "",
                    });
                    setSubmitting(false);
                }}
            >
                {({ values, errors, handleChange, handleBlur, handleSubmit, isSubmitting, setFieldValue, resetForm }) => (
                    <form className="ui form" onSubmit={handleSubmit}>
                        <Grid centered>
                            <Grid.Row>
                                <Grid.Column width={8}>
                                    {userUid.length === 1 && <MyTextInput label="Email*:" name="email" type="text" placeholder="Email Address" />}
                                    {userUid.length === 1 && <MyTextInput label="Password*:" name="password" type="password" placeholder="Password" />}

                                    <MyTextInput label="Full Name*:" name="displayName" type="text" placeholder="Known As" />

                                    <MyTextInput label="Cell Number:" name="cellNumber" type="text" placeholder="Cell Number" />

                                    <Grid>
                                        {currentUserProfile && currentUserProfile?.isSuper && (
                                            <Grid.Row columns={5}>
                                                <Grid.Column>
                                                    <label>Role:</label>
                                                </Grid.Column>

                                                <Grid.Column>
                                                    <MyCheckboxInput labelcb="Consultant" name="isConsultant" type="checkbox" />
                                                </Grid.Column>

                                                <Grid.Column>
                                                    <MyCheckboxInput labelcb="Super User" name="isSuper" type="checkbox" />
                                                </Grid.Column>

                                                <Grid.Column>
                                                    <MyCheckboxInput labelcb="Reports" name="isReports" type="checkbox" />
                                                </Grid.Column>

                                                <Grid.Column>
                                                    <MyCheckboxInput labelcb="External Consultant" name="isExternal" type="checkbox" />
                                                </Grid.Column>
                                            </Grid.Row>
                                        )}
                                        {currentUserProfile && currentUserProfile?.isSuper && (
                                            <Grid.Row columns={2}>
                                                <Grid.Column>
                                                    <label>Group:</label>
                                                </Grid.Column>
                                                <Grid.Column>
                                                    <MyCheckboxInput labelcb="Current Travel Agent" name="isCurrentAgent" type="checkbox" />
                                                </Grid.Column>
                                            </Grid.Row>
                                        )}
                                        {currentUserProfile && currentUserProfile?.isAdmin && (
                                            <Grid.Row columns={5}>
                                                <Grid.Column>
                                                    <label>Admin:</label>
                                                </Grid.Column>
                                                <Grid.Column>
                                                    <MyCheckboxInput labelcb="Admin" name="isAdmin" type="checkbox" />
                                                </Grid.Column>
                                                <Grid.Column>
                                                    <MyCheckboxInput labelcb="Sys Admin" name="isSysAdmin" type="checkbox" />
                                                </Grid.Column>
                                                {currentUserProfile?.isSysAdmin && (
                                                    <Grid.Column>
                                                        <MyCheckboxInput labelcb="Manage Templates" name="isManageTemplates" type="checkbox" />
                                                    </Grid.Column>
                                                )}
                                                <Grid.Column>
                                                    <MyCheckboxInput labelcb="Tester" name="is_tester" type="checkbox" />
                                                </Grid.Column>
                                            </Grid.Row>
                                        )}
                                        {currentUserProfile && currentUserProfile?.isSysAdmin && (
                                            <Grid.Row columns={2}>
                                                <Grid.Column>
                                                    <label>Access:</label>
                                                </Grid.Column>
                                                <Grid.Column>
                                                    <MyCheckboxInput labelcb="Disable Login" name="isDisabled" type="checkbox" />
                                                </Grid.Column>
                                            </Grid.Row>
                                        )}
                                        {currentUserProfile && currentUserProfile?.isSuper && (
                                            <Grid.Row columns={4}>
                                                <Grid.Column>
                                                    <label>Dashboard:</label>
                                                </Grid.Column>

                                                <Grid.Column>
                                                    <MyCheckboxInput labelcb="Show" name="showDashboard" type="checkbox" />
                                                </Grid.Column>
                                            </Grid.Row>
                                        )}
                                        {currentUserProfile && currentUserProfile?.isSuper && (
                                            <Grid.Row columns={4}>
                                                <Grid.Column>
                                                    <label>Use Mailtrap:</label>
                                                </Grid.Column>
                                                <Grid.Column>
                                                    <MyCheckboxInput labelcb="Yes" name="mailtrap" type="checkbox" />
                                                </Grid.Column>
                                            </Grid.Row>
                                        )}
                                        {currentUserProfile && currentUserProfile?.isSuper && (
                                            <Grid.Row columns={1}>
                                                <Grid.Column>
                                                    <MySelectInput label="Division" name="division" type="text" placeholder="Choose a Division" options={divisionOptions} />
                                                </Grid.Column>
                                            </Grid.Row>
                                        )}
                                        <Grid.Row columns={1} style={{ marginTop: "10px" }}>
                                            <Grid.Column>
                                                <MySelectInput
                                                    label="Lead Status Order"
                                                    name="leadStatusOrder"
                                                    type="text"
                                                    placeholder="Choose an Order"
                                                    options={leadStatus}
                                                    onChange={(field, value) => {
                                                        const nextValue = value?.value || "";
                                                        setFieldValue("leadStatusOrder", nextValue);
                                                    }}
                                                />
                                            </Grid.Column>
                                        </Grid.Row>

                                        <Grid.Row columns={1} style={{ marginTop: "10px" }}>
                                            <Grid.Column>
                                                <MySelectInput
                                                    label="No. of Months to Load"
                                                    name="noLeadsLoad"
                                                    type="text"
                                                    placeholder="Select history"
                                                    options={historyMonthOptions}
                                                    onChange={(field, value) => {
                                                        const nextValue = value?.value ?? "";
                                                        setFieldValue("noLeadsLoad", nextValue);
                                                    }}
                                                />
                                                <small>Select All time to load all leads</small>
                                            </Grid.Column>
                                        </Grid.Row>

                                        <Grid.Row columns={1}>
                                            <Grid.Column>
                                                <MyTinyMCE name="moreInfoMessage" label="More Info Message" type="text" onEditorChange={(value) => setFieldValue("moreInfoMessage", value)} />
                                            </Grid.Column>
                                        </Grid.Row>

                                        <Grid.Row columns={1}>
                                            <Grid.Column>
                                                <MyTinyMCE name="defaultMessage" label="Default Message" type="text" onEditorChange={(value) => setFieldValue("defaultMessage", value)} />
                                            </Grid.Column>
                                        </Grid.Row>

                                        <Grid.Row columns={1}>
                                            <Grid.Column>
                                                <MyTinyMCE
                                                    name="defaultQuoteMessage"
                                                    label="Default Quote Message"
                                                    type="text"
                                                    onEditorChange={(value) => setFieldValue("defaultQuoteMessage", value)}
                                                />
                                            </Grid.Column>
                                        </Grid.Row>

                                        <Grid.Row columns={1}>
                                            <Grid.Column>
                                                <MyTinyMCE
                                                    name="defaultBookingMessage"
                                                    label="Default Booking Message"
                                                    type="text"
                                                    helperText={
                                                        <>
                                                            Use placeholders instead of pasting URLs. The app/functions will inject/remove the final links at send time.
                                                            <br />
                                                            Available tokens: <code>{"{{TERMS_SIGN_LINK}}"}</code>,{" "} <code>{"{{BOOKING_SIGN_LINK}}"}</code>.
                                                        </>
                                                    }
                                                    tokenButtons={[
                                                        { name: "insert_terms_sign", text: "Insert Terms Sign Link", token: "{{TERMS_SIGN_LINK}}" },
                                                        { name: "insert_booking_sign", text: "Insert Booking Sign Link", token: "{{BOOKING_SIGN_LINK}}" },
                                                    ]}
                                                    onEditorChange={(value) => setFieldValue("defaultBookingMessage", value)}
                                                />
                                            </Grid.Column>
                                        </Grid.Row>

                                        {userUid.length !== 1 && (
                                            <Grid.Row columns={2}>
                                                <Grid.Column>
                                                    <label>Email Signature</label>
                                                    <input
                                                        id="uploadFile"
                                                        name="uploadFile"
                                                        type="file"
                                                        onChange={(event) => {
                                                            setFieldValue("uploadFile", event.currentTarget.files[0]);
                                                        }}
                                                        className="form-control"
                                                    />

                                                    {user.fileUrl && user.fileUrl.length > 0 && <Image size="small" style={{ marginTop: 20 }} src={user.fileUrl} />}
                                                </Grid.Column>
                                            </Grid.Row>
                                        )}
                                    </Grid>
                                </Grid.Column>
                            </Grid.Row>

                            <Grid.Row>
                                <Grid.Column width={8}>
                                    <Divider />

                                    <Button type="submit" disabled={isSubmitting} loading={isSubmitting} size="large" color="orange" content={userUid.length > 1 ? "Update User" : "Create User"} />

                                    {currentUserProfile && currentUserProfile?.isAdmin && userUid.length > 1 && (
                                        <Button
                                            type="button"
                                            disabled={impersonating}
                                            loading={impersonating}
                                            size="large"
                                            color="blue"
                                            content="Impersonate User"
                                            onClick={impersonateSelectedUser}
                                        />
                                    )}

                                    <Button size="large" as={Link} to={`/admin/users/`}>
                                        Cancel
                                    </Button>
                                </Grid.Column>
                            </Grid.Row>
                        </Grid>
                    </form>
                )}
            </Formik>
        </Container>
    );
}
